module.exports = __webpack_public_path__ + "static/media/qr_code.19f90b82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr_code.svg
// module id = 2465
// module chunks = 0